export class ClearAlertFlag {
    public static readonly type = '[MessagingState] Clear alert flag';
}
